export default "__VITE_ASSET__BeN5vhUW__"